import * as Sentry from "@sentry/browser";
import {
  getAccessTokenByRefreshToken,
  readFromLocalStorage,
  readFromSessionStorage,
} from "@bn/api";
import { revokeToken } from "@bn/api/apiv1";

export const readStoredToken = (): Token | undefined =>
  readFromSessionStorage() ?? readFromLocalStorage();

const isExpired = (token: Token) =>
  !token.expires_at || new Date(token.expires_at).getTime() <= Date.now();

/**
 * Revokes all of the user's wealthAPI refresh tokens, so a copy of the token
 * left in the browser cannot be used again. Best effort: failures only go to
 * Sentry, since the local logout must not depend on it.
 */
export const revokeWealthApiTokens = async (token: Token) => {
  try {
    const accessToken = isExpired(token)
      ? (
          await getAccessTokenByRefreshToken({
            refreshToken: token.refresh_token,
          })
        ).access_token
      : token.access_token;
    await revokeToken(accessToken);
  } catch (error) {
    Sentry.captureException(error);
  }
};
